<template>

      <v-autocomplete
        v-model="selAirport"
        :items="airports"
        persistent-hint
        :loading="isLoading"
        :search-input.sync="search"
        hide-no-data
        no-filter
        :prepend-icon=this.icon
        placeholder="Airport,City"
        browser-autocomplete="disabled"
        @change="selectAirport()"
        :disabled="disabled"
        clearable
        append-icon=""
        clear-icon="cancel"
      >
        <template v-slot:append-outer>
          <v-slide-x-reverse-transition
            mode="out-in"
          >
          </v-slide-x-reverse-transition>
        </template>
      </v-autocomplete>

</template>

<script>
import SearchBoxService from "../../services/searchBox.service";

export default {
    created(){
      this.isFirstLoad =true;
      //this.airports = ["DMK - Don Mueang International Arpt , Thailand"];
      //this.selAirport = "DMK - Don Mueang International Arpt , Thailand";
      
      if (this.setAirport!=null&&
          this.setAirport!=""
          ){
        this.airports = [this.setAirport];
        this.selAirport = this.setAirport;
        this.selectAirport();
      }
      setTimeout(() => {
        //this.airports = this.cityAirports;        
      }, 2000);
    },
    props:['icon','cityAirports','setAirport','disabled',],
    data(){
        return {
            isFirstLoad:false,
            selAirport:null,
            airports:[],
            isLoading:false,
            search:null,
            uiCaptions:{
              acAirport:"",
            },
        }
    },
    computed:{
      selectedAirport(){
        return this.selAirport;
      },
      cpCityAirports(){
        let rslt;
        if (this.cityAirports!=null){
          //rslt = this.cityAirports;
        }else{
          //rslt = [];
        }
        return rslt;
      },
    },
    watch:{
      search(val){
        if (this.isFirstLoad) {
          this.isFirstLoad = false; 
          return;
        }
        this.getCityAirports(val);
      },
    },
    methods:{
      selectAirport(){
        this.$emit('airportSelected',this.selectedAirport);
      },
      getCityAirports(searchText){
        SearchBoxService.getCityAirportsFromApi(searchText).then(rslt=>{
          if(rslt.data.length>0){
          this.airports = rslt.data==""? []:rslt.data;
          }
        });
      },
    }
}
</script>

<style>

</style>
